import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import {
  absenceSupervisorApi,
  TAbsenceGetResponseSubstitutionPaginated,
} from 'app/services/edpApiV1/supervisor/absenceSupervisor';

type TInitialState = {
  loading: boolean;
  success: boolean;
  error?: string;
} & TAbsenceGetResponseSubstitutionPaginated;

const initialState: TInitialState = {
  pagination: { page: 1, size: 10, total: 0 },
  data: [],
  loading: false,
  success: false,
};

export const absenceSupervisorSlice = createSlice({
  name: 'absenceSupervisor',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        absenceSupervisorApi.endpoints.getAllAbsenceActing.matchFulfilled,
        (state, { payload }: PayloadAction<TAbsenceGetResponseSubstitutionPaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(absenceSupervisorApi.endpoints.getAllAbsenceActing.matchRejected, () => initialState)
      .addMatcher(absenceSupervisorApi.endpoints.getAllAbsenceActing.matchPending, state => {
        state.loading = true;
        state.success = false;
      })
      .addMatcher(
        absenceSupervisorApi.endpoints.getAllAbsenceDeputy.matchFulfilled,
        (state, { payload }: PayloadAction<TAbsenceGetResponseSubstitutionPaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(absenceSupervisorApi.endpoints.getAllAbsenceDeputy.matchRejected, () => initialState)
      .addMatcher(absenceSupervisorApi.endpoints.getAllAbsenceDeputy.matchPending, state => {
        state.loading = true;
        state.success = false;
      })
      .addMatcher(
        absenceSupervisorApi.endpoints.getAllAbsenceTimekeeper.matchFulfilled,
        (state, { payload }: PayloadAction<TAbsenceGetResponseSubstitutionPaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(absenceSupervisorApi.endpoints.getAllAbsenceTimekeeper.matchRejected, () => initialState)
      .addMatcher(absenceSupervisorApi.endpoints.getAllAbsenceTimekeeper.matchPending, state => {
        state.loading = true;
        state.success = false;
      })
      .addMatcher(
        absenceSupervisorApi.endpoints.getAllAbsenceSupervisor.matchFulfilled,
        (state, { payload }: PayloadAction<TAbsenceGetResponseSubstitutionPaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(absenceSupervisorApi.endpoints.getAllAbsenceSupervisor.matchRejected, () => initialState)
      .addMatcher(absenceSupervisorApi.endpoints.getAllAbsenceSupervisor.matchPending, state => {
        state.loading = true;
        state.success = false;
      });
  },
});

const absence = (state: RootState) => state.entities.supervisor.absenceSupervisorReducer;
export const getAbsenceSupervisor = createSelector(absence, state => state);

export const actions = absenceSupervisorSlice.actions;
export const reducer = absenceSupervisorSlice.reducer;
